module.exports = __webpack_public_path__ + "174cd19e5d3977b610d1863d5031f06f.svg";